import ymapsRequire from '../../../../serp/helpers/ymaps-reqiure.js';

angular.module('cian.mapDraw').directive('mapDraw', () => {
  return {
    scope: {},
    bindToController: {
      geo: '=',
      selectedRegion: '='
    },
    template: require('../../templates/map-draw.html'),
    restrict: 'EA',
    controller: [
      '$element',
      '$uibModal',
      'FilterBackup',
      'AnalyticsService',
      function($element, $uibModal, FilterBackup, AnalyticsService) {
      this.isPopupOpen = false;

      angular.element($element[0].querySelector('.s-button')).on('click', () => {
        if (!this.isPopupOpen) {
          this.isPopupOpen = true;

          FilterBackup.backup();
          AnalyticsService.trackCA('Listing', 'popup_map_open');

          ymapsRequire(['Map', 'Placemark'], () => {
            $uibModal.open({
              animation: true,
              windowClass: 'filter__map-draw-popup serp-modal',
              template: require('../../templates/map-draw.popup.html'),
              controller: 'MapDrawCtrl',
              controllerAs: 'modal',
              resolve: {
                mapCenter: () => [this.selectedRegion.lng, this.selectedRegion.lat],
                // Защитное копирование, чтобы случайно из попапа не поменять данные в фильтре
                selectedShapes: () => angular.copy(this.geo.filter(item => ['polygon', 'circle'].includes(item.type))),
                geoFilters: () => this.geo,
              }
            }).result
              .then(null, FilterBackup.restore)
              .finally(() => this.isPopupOpen = false);
          });
        }
      });
    }],
    controllerAs: 'mapDraw'
  };
});



// WEBPACK FOOTER //
// ./src/components/map-draw/src/scripts/cian.map-draw.dir.js